import DxDisappearingNotifier from './dx-disappearing-notifier';

export const notifier = new DxDisappearingNotifier();
